// @ts-nocheck
import { Canvas } from '@react-three/fiber';
import { Bloom, EffectComposer, Vignette } from '@react-three/postprocessing';
import SceneRenderer from './scenes/SceneRenderer';
import { usePartyStore } from './store/partyStore';

function SceneLighting() {
  const palette = usePartyStore((s) => s.currentTrack?.palette);
  const color = palette ? `rgb(${palette.glow.join(',')})` : '#ffffff';

  return (
    <>
      <color attach="background" args={[palette ? `rgb(${palette.background.join(',')})` : '#000000']} />
      <ambientLight intensity={0.35} />
      <pointLight position={[4, 6, 4]} intensity={1.4} color={color} />
      <pointLight position={[-6, -2, -4]} intensity={0.8} color={color} />
    </>
  );
}

function ScenePostEffects() {
  const intensity = usePartyStore((s) => s.activeEvent?.intensity ?? 0.7);
  return (
    <EffectComposer multisampling={0}>
      <Bloom
        mipmapBlur
        intensity={0.48 + intensity * 0.32}
        luminanceThreshold={0.12}
        luminanceSmoothing={0.45}
      />
      <Vignette eskil={false} offset={0.22} darkness={0.48} />
    </EffectComposer>
  );
}

export default function PartyCanvas() {
  return (
    <div className="party-canvas-wrap">
      <Canvas
        camera={{ position: [0, 0, 5], fov: 60 }}
        dpr={[1, 2]}
        gl={{ antialias: true, alpha: false, powerPreference: 'high-performance' }}
      >
        <SceneLighting />
        <SceneRenderer />
        <ScenePostEffects />
      </Canvas>
    </div>
  );
}
